import React, { useContext } from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore.ts';
import { writeSettings } from '../../../Utils/db/users/userSettings/writeSettings.ts';
import { GlobalContext } from '../../../App.tsx';
import { BsIncognito } from 'react-icons/bs';

const IncognitoBanner: React.FC = () => {
    const { resetStateHelper, messagesSequenceRef } = useContext(GlobalContext);
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { isIncognito } = settingsObj;

    const handleDisableIncognito = () => {
        writeSettings(userObj.user, { incognitoMode: false }, environmentObj.environment);
        setSettingsObj({
            isIncognito: false
        });
        setDynamicStateObj({ conversationId: null });
        
        if (messagesSequenceRef.current.length !== 0) {
            setDynamicStateObj({ visiblePopup: 'askToSave' });
        } else {
            resetStateHelper();
        }
    };

    if (!isIncognito) {
        return null;
    }
    return (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-40 w-52">
            <div className="bg-white/95 dark:bg-neutral-800/95 backdrop-blur-sm border border-neutral-200 dark:border-neutral-700 rounded-xl p-4 shadow-lg">
                <div className="text-center space-y-4">
                    <h3 className="text-base font-semibold text-neutral-800 dark:text-neutral-200">
                        Incognito Mode
                    </h3>
                    <div className="flex justify-center">
                        <BsIncognito size={20} className="text-neutral-600 dark:text-neutral-400" />
                    </div>
                    <button
                        onClick={handleDisableIncognito}
                        className="px-3 py-1.5 text-sm font-medium text-neutral-700 dark:text-neutral-300 bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 dark:hover:bg-neutral-600 rounded-md transition-colors duration-200"
                    >
                        Turn Off
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IncognitoBanner;